package navigation.settings

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.collectSuccessEvent
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class SettingsViewModel(
    private val getCurrentUserUseCase: GetCurrentUserUseCase,
    private val state: MutableStateFlow<SettingsState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    init {
        getCurrentProfile()

        // Get Current User Use Case
        collectSuccessEvent(
            flow = getCurrentUserUseCase.successEvent,
            getState = { state.value.getProfile },
            setState = { newState -> state.update { it.copy(getProfile = newState) } },
        )
    }

    private fun getCurrentProfile() =
        scope.launch {
            getCurrentUserUseCase.get()
        }
}